import { imgCamera_1, imgCamera_2, imgCloud_1, imgCloud_2, imgCloudFront_1, 
         imgCloudFront_2, imgHeart_1, imgHeart_2, imgHeartSm_1, imgHeartSm_2, 
         imgHistory_1, imgHistory_2,imgSearch_1, imgSearch_2, imgSign_1, 
         imgSign_2, imgWrench_1, imgWrench_2, imgHandHeart, imgHandHeart2, imgHandHeart3, imgLetters } from "../../utils/HubImgIndex";
import { vidCamera, vidDatasetBuilder, vidDonate, vidSearch, imgRobot, imgRobot2, imgMoveYourSkeleton, vidVersusMachine, vidMoveYourSkeleton, imgSurvey } from "../../utils/HubImgIndex";
import { pDB_user_roles } from '../../utils/parameters.js';


const HubsAllItems = {
    'searchBySign':{
        cardID: 1,
        cardImg: imgCamera_1,
        cardTitle: 'sDrawer.searchBySign',
        cardText: 'sHub.searchBySign',
        cardVideo: vidCamera,
        cardVideoTutorial: "https://www.youtube.com/watch?v=g0f0p3ei-0Y",
        cardLink: "/camera",
        roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'searchByText':{
        cardID: 2,
        cardImg: imgSearch_1,
        cardTitle: 'sDrawer.searchByText',
        cardText: 'sHub.searchByText',
        cardVideo: vidSearch,
        cardVideoTutorial: "https://www.youtube.com/watch?v=BTwOdafKqTI",
        cardLink: "/search",
        roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'datasetbuilder':{
        cardID: 3,
        cardImg: imgWrench_1,
        cardTitle: 'sDrawer.datasetbuilder',
        cardText: 'sHub.datasetbuilder',
        cardVideo: vidDatasetBuilder,
        cardVideoTutorial: "",
        cardLink: "/datasetbuilder",
        roles: [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'donateSign':{
        cardID: 4,
        cardImg: imgSign_1,
        cardTitle: 'sDrawer.donateSign',
        cardText: 'sHub.donateSign',
        cardVideo: vidDonate,
        cardVideoTutorial: "https://www.youtube.com/watch?v=MrO3qSaz0qU",
        cardLink: "/donateSign",
        roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'donateSentence':{
        cardID: 5,
        cardImg: imgHandHeart,
        cardTitle: 'sDrawer.donateSentence',
        cardText: "",
        cardVideo: vidDonate,
        cardVideoTutorial: null,
        cardLink: "/donateSentence",
        roles: [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'versusMachine':{
        cardID: 6,
        cardImg: imgRobot,
        cardTitle: 'sDrawer.versusMachine',
        cardText: 'sHub.versusMachine',
        cardVideo: vidVersusMachine,
        cardVideoTutorial: "https://www.youtube.com/watch?v=25JbTJ0LlOg",
        cardLink: "/versusMachine",
        roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'versusMachine2':{
        cardID: 7,
        cardImg: imgRobot2,
        cardTitle: 'sDrawer.versusMachine2',
        cardText: 'sHub.versusMachine',
        cardVideo: vidVersusMachine,
        cardVideoTutorial: "https://www.youtube.com/watch?v=9HTsQkyA1jI",
        cardLink: "/versusMachine2",
        roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },
    'moveYourSkeleton': {
        cardID: 8,
        cardImg: imgMoveYourSkeleton,
        cardTitle: 'sDrawer.moveYourSkeleton',
        cardText: 'sHub.moveYourSkeleton',
        cardVideo: vidMoveYourSkeleton,
        cardVideoTutorial: "https://www.youtube.com/watch?v=zgwkCSpgtEk",
        cardLink: "/moveYourSkeleton",
        roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
      },
    
    'survey': {
        cardID: 9,
        cardImg: imgSurvey,
        cardTitle: 'sDrawer.survey',
        cardText: "",
        cardVideo: vidMoveYourSkeleton,
        cardVideoTutorial: null,
        cardLink: "/survey",
        roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },

    'donateFingerspelling':{
        cardID: 10,
        cardImg: imgLetters,
        cardTitle: 'sDrawer.donateFingerspelling',
        cardText: "",
        cardVideo: vidDonate,
        cardVideoTutorial: null,
        cardLink: "/donateFS",
        roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    },





      
    //   'TelegramBot': {
    //     cardID: 8,
    //     cardImg: imgMoveYourSkeleton,
    //     cardTitle: sDrawer.telegramBot,
    //     cardText: sHub.moveYourSkeleton,
    //     cardVideo: vidMoveYourSkeleton,
    //     cardVideoTutorial: "https://www.youtube.com/watch?v=zgwkCSpgtEk",
    //     cardLink: "/moveYourSkeleton",
    //     roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
    //   },

}



export const HubDiccionaries = [
    HubsAllItems.searchBySign, HubsAllItems.searchByText, HubsAllItems.donateSign, HubsAllItems.donateSentence, HubsAllItems.donateFingerspelling
]

export const HubGames = [
    // HubsAllItems.datasetbuilder, HubsAllItems.donateSign, HubsAllItems.versusMachine
    HubsAllItems.versusMachine, HubsAllItems.versusMachine2, HubsAllItems.moveYourSkeleton
]
